module.exports = __webpack_public_path__ + "pc/img/magazine03.a2f00706.jpg";